export default {
  background: {
    default: "#0F75BC",
  },

  backgroundCard: {
    main: "#FFFFFF",
  },

  text: {
    main: "#ffffff",
    focus: "#D3D3D3",
    white: "#FFFFFF",
    light: "#E1EEF7",
    lightAccent: "#779CD4",
    dark: "#0F75BC",
    darkAccent: "#0055AA",
    black: "#00385F",
    transparent: "transparent",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#175cd3",
    focus: "#175cd3",
    white: "#FFFFFF",
    light: "#E1EEF7",
    lightAccent: "779CD4",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
    dark: "#0F75BC",
    darkAccent: "#0055AA",
    black: "#000000",
  },

  primary: {
    main: "#0F75BC",
    focus: "#0055AA",
    blue: "#175cd3",
    white: "#FFFFFF",
    light: "#E1EEF7",
    lightAccent: "#779CD4",
    dark: "#0F75BC",
    darkAccent: "#0055AA",
    black: "#00385F",
  },

  secondary: {
    main: "#E1EEF7",
    focus: "#779CD4",
  },

  info: {
    main: "#0F75BC",
    focus: "#E1EEF7",
  },

  success: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  error: {
    main: "#F44335",
    focus: "#f65f53",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#3da8f0",
      state: "#175cd3",
    },

    secondary: {
      main: "#747b8a",
      state: "#495361",
    },

    info: {
      main: "#3da8f0",
      state: "#175cd3",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#42424a",
      state: "#191919",
    },

    darkAccent: {
      main: "#acc2e4",
      state: "#0055AA",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#3da8f0",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#0F75BC",
      text: "#E1EEF7",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#3da8f0",
    secondary: "#110e0e",
    info: "#3da8f0",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};
